<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="loanProduct.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', loanProduct.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="sku">SKU</label>
            <input
                id="sku"
                v-model="loanProduct.sku"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('sku')
                }"
                dir="auto"
                placeholder="SKU"
            />
            <div class="invalid-feedback">
                {{ getError('sku') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="description">Description</label>
            <textarea
                id="description"
                v-model="loanProduct.description"
                type="text"
                class="form-control rtl"
                :class="{
                    'is-invalid': hasError('description')
                }"
                dir="auto"
                rows="4"
                placeholder="Description"
            />
            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="loanPeriod">Loan period</label>
            <input
                id="loanPeriod"
                v-model="loanProduct.loanPeriod"
                type="number"
                min="0"
                class="form-control"
                :class="{
                    'is-invalid': hasError('loanPeriod')
                }"
                placeholder="Loan period"
            />
            <div class="invalid-feedback">
                {{ getError('loanPeriod') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label>Disclaimer</label>
            <disclaimer-selector v-model="loanProduct.disclaimerId" />
        </div>
        <div class="form-group col-12">
            <label>
                Gallery
            </label>
            <media-chooser
                v-model="loanProduct.gallery"
                type="image"
                multiple
            />
        </div>
        <div class="form-group col-6">
            <label for="stockAmount">Stock Amount</label>
            <input
                id="stockAmount"
                v-model="loanProduct.stockAmount"
                type="number"
                class="form-control"
                :disabled="editMode"
                :class="{
                    'is-invalid': hasError('stockAmount')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('stockAmount') }}
            </div>
        </div>
        <div v-if="editMode" class="col-2 d-flex align-items-end form-group">
            <button v-b-modal.change-stock-amount-modal class="btn btn-success">
                Change Amount
            </button>
        </div>

        <change-stock-amount-modal
            v-if="editMode"
            :item-id="loanProduct.id"
            action-name="loanProducts/changeStockAmount"
            @amount-updated="loanProduct.stockAmount = $event"
        />
    </div>
</template>

<script>
import DisclaimerSelector from '@/components/disclaimers/Selector';
import ChangeStockAmountModal from '@/components/elements/ChangeStockAmountModal';

export default {
    components: {
        DisclaimerSelector,
        ChangeStockAmountModal
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            loanProduct: {}
        };
    },

    watch: {
        loanProduct() {
            this.$emit('input', this.loanProduct);
        }
    },

    created() {
        this.loanProduct = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.loanProduct[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.loanProduct,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
